/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 8:41 PM
 *
 */

import { Helmet } from 'react-helmet';
import { useAppSelector } from 'stores';

import StatCardGroup, { StatCardGroupVariant2 } from '../components/StatCardGroup';
import { Loader } from '@sunyahealthnepal/react-ui-components';

import { useDashboardQuery } from '../query/useDashboardQuery';

export const DashboardPage = () => {
  const user = useAppSelector((state) => state.auth.user);
  const roleData = useAppSelector((state) => state.auth?.user?.role.role_access);

  const { data, isLoading } = useDashboardQuery(Number(user?.id), roleData);

  if (isLoading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>Dashboard | School Health</title>
      </Helmet>
      <div className="dashboard-bg w-full space-y-14 px-10 pb-8 sm:-mt-12 sm:px-6 sm:py-6">
        <div>
          <h1 className="text-5xl font-medium text-gray-800 sm:text-2xl ">Hello, {user?.name}</h1>
          <p className="text-xl font-medium text-gray-500">Welcome Back To Dashboard!</p>
        </div>
        <div className="relative flex w-full items-start gap-6 md:flex-col sm:gap-4">
          <div className="flex h-full w-5/6 flex-col gap-6 md:w-full md:gap-4">
            <StatCardGroup data={data} />
            <StatCardGroupVariant2 data={data} user={user} />
          </div>
        </div>
      </div>
    </>
  );
};
